// @flow

import React from 'react';

import type { Reason } from 'app/common/components/UpgradeInlineModal/types';

type Props = {
  reasons: Reason[],
};

const ReasonsMessage = ({ reasons = [] }: Props) => {
  return <span>{reasons.map(r => r.reason).join(' ')}</span>;
};

export default ReasonsMessage;
